export const DiscountPromotionRule = (json: IDiscountPromotionRule): IDiscountPromotionRuleModel => {
	const { id, title, type, promotion_id, configuration } = json

	return {
		id,
		title,
		type,
		configuration,
		promotionId: promotion_id,
	}
}

/**
 * Payloads
 */
export const PromotionRuleCreatePayload = (
	type: EPromotionRuleType,
	configuration: IDiscountPromotionRulePayloadConfiguration,
): IDiscountPromotionRuleCreatePayload => ({
	type,
	configuration,
})
